export const ACTION_REQUIRED_COUNTS_UPDATED_EVENT = 'gd:actionRequiredCountsUpdated';
